<template>
  <div>
    <header-top></header-top>
    <div class="business">
      <div class="businessBox" :class="{en:language!=='zh'}">
        <p class="title">{{$t('business.MANA商务合作')}}</p>
        <div class="navBox clearfix">
          <div class="navTitle">
            <i class="img4"></i>
            <p class="title1">{{$t('business.资源对接')}}</p>
            <p class="title2">{{$t('business.推荐适配团队/作品')}}</p>
            <div class="buttomBox">
              <a href="https://manabang.mikecrm.com/g4yVMM9" target="_blank" class="buttom1">{{$t('business.我有需求')}}</a>
            </div>
          </div>
          <div class="navTitle">
            <i class="img1"></i>
            <p class="title1">{{$t('business.活动')}}</p>
            <p class="title2">{{$t('business.论坛 / 沙龙 / 讲座 / 演出 / 工作坊 / 展览 / 直播 /其他')}}</p>
            <div class="buttomBox">
              <a href="http://manabang.mikecrm.com/OLlezsk" target="_blank" class="buttom1">{{$t('business.我要合作')}}</a>
            </div>
          </div>
          <div class="navTitle">
            <i class="img3"></i>
            <p class="title1">{{$t('business.竞赛与征集')}}</p>
            <p class="title2">{{$t('business.全案策划 / 征集及推广 / 评委及评选 / 活动及转化')}}</p>
            <div class="buttomBox">
              <a href="http://manabang.mikecrm.com/WZl9NT3" target="_blank" class="buttom1">{{$t('business.我要合作')}}</a>
            </div>
          </div>
          <div class="navTitle">
            <i class="img2"></i>
            <p class="title1">{{$t('business.广告推广')}}</p>
            <p class="title2">{{$t('business.网站 / APP / 微信公众号')}}</p>
            <div class="buttomBox1 clearfix">
              <a href="http://manabang.mikecrm.com/iVUslu2" target="_blank" class="buttom1">{{$t('business.预约服务')}}</a>
              <p class="buttom2" @click="gotoDetail">{{$t('business.了解详情')}}</p>
            </div>
          </div>
        </div>
        <div class="phone">
          <p class="title1">{{$t('business.其它商务服务')}}</p>
          <p class="title2">{{$t('business.服务热线')}}：021-52998050</p>
          <a class="title3" href="mailto:business@manamana.net">{{$t('business.商务合作邮箱')}}：business@manamana.net</a>
          <p class="title4">{{$t('business.workTime')}}</p>
        </div>
      </div>
    </div>
    <footer-down class="searchFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";

export default {
  name: "business",
  metaInfo() {
    return {
      title: this.$t('business.商务合作') + " | MANA",
    };
  },
  components: {
    HeaderTop,
    FooterDown,
  },
  data() {
    return {};
  },
  created() {
    this.buriedPoint(19,0)
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    gotoDetail() {
      let routeData = this.$router.resolve({ path: "/advertisement" });
      window.open(routeData.href, "_blank");
    }
  },
  watch: {
    $route(to, from) {},
  },
};
</script>

<style lang="stylus" scoped>
.searchFooter {
  position: relative !important;
}

.business {
  background: #fff;
  padding: 70px 0 120px 0;

  .businessBox {
    width: 1110px;
    margin: 0 auto;

    .title {
      font-size: 44px;
      font-weight: bold;
      color: #0A0A0A;
    }

    .navBox {
      margin: 60px 0 0 0;

      .navTitle {
        width: 255px;
        padding-bottom: 30px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
        float: left;
        margin-right: 30px;
        text-align: center;
        &:last-child {
          margin-right: 0;
        }

        i.img1 {
          width: 100px;
          height: 100px;
          background: url('https://image.manamana.net/web_business_img_01_event@2x.png') no-repeat;
          background-size: 100% 100%;
          display: inline-block;
          margin: 16px 0 8px 0;
        }
        i.img2 {
          width: 100px;
          height: 100px;
          background: url('https://image.manamana.net/web_business_img_02_marketing@2x.png') no-repeat;
          background-size: 100% 100%;
          display: inline-block;
          margin: 16px 0 8px 0;
        }
        i.img3 {
          width: 100px;
          height: 100px;
          background: url('https://image.manamana.net/web_business_img_03_contest@2x.png') no-repeat;
          background-size: 100% 100%;
          display: inline-block;
          margin: 16px 0 8px 0;
        }
        i.img4 {
          width: 100px;
          height: 100px;
          background: url('https://image.manamana.net/1668488198000_LMtSIYZK') no-repeat;
          background-size: 100% 100%;
          display: inline-block;
          margin: 16px 0 8px 0;
        }

        .title1 {
          font-size: 24px;
          font-weight: 600;
          color: #0A0A0A;
          width: 190px;
          margin: 0 auto;
          text-align: center;
        }

        .title2 {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          width: 190px;
          margin: 16px auto 32px;
          text-align: center;
          line-height: 24px;
          height: 48px;
        }

        .buttomBox {
          text-align: center
          .buttom1 {
            width: 100px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            background: #2026CC;
            border-radius: 2px;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            display: inline-block;
          }
        }

        .buttomBox1 {
          text-align: center

          .buttom1 {
            width: 100px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            background: #2026CC;
            border-radius: 2px;
            font-size: 14px;
            font-weight: 600;
            color: #FFFFFF;
            display: inline-block;
            cursor: pointer;
          }

          .buttom2 {
            width: 100px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            border-radius: 2px;
            border: 1px solid #2026CC;
            font-size: 14px;
            font-weight: 600;
            color: #2026CC;
            display: inline-block;
            margin-left: 15px;
            cursor: pointer;
          }
        }
      }
    }

    .phone {
      margin-top: 100px;

      .title1 {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }

      .title2 {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin: 24px 0 16px 0;

        a {
          font-weight: bold;
          color: #2026cc;
        }
      }

      .title3 {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }

      .title4 {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-top: 16px;
      }
    }

    &.en {
      .navBox .navTitle {
        .title1 {
          height: 60px;
          font-size: 20px;
        }

        .title2 {
          height: 66px;
          font-size: 13px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/business.vue